<template>
  <div id="home">
    <my-header ref="header"></my-header>
    <div class="pd20 login-page landing-page">
      <div class="row">
        <div class="col-md-8 col-md-offset-2">
          <div class="row">
            <div class="col-md-6">
              <img src="/static/images/landing/d_garden.jpg" />
            </div>
            <div class="col-md-6">
              <h3>Dành cho nhà vườn</h3>
              <p>Quản lý hồ sơ vườn, nhật ký sản xuất, vật tư, sản lượng thu hoạch, tìm kiếm khách hàng...</p>

              <button class="btn btn-success text-center btn-lg" v-if="!user" v-on:click="register('farmer')">
                <i class="fas fa-key"></i> Đăng ký
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mt40">
              <h3>Dành cho nhà bán lẻ</h3>
              <p>Tìm kiếm nguồn hàng, quản lý nhập hàng</p>

              <button class="btn btn-success text-center btn-lg" v-if="!user" v-on:click="register('retailer')">
                <i class="fas fa-key"></i> Đăng ký
              </button>
            </div>
            <div class="col-md-6 mt40">
              <img src="/static/images/landing/d_store.jpg" />
            </div>
          </div>

          
        </div>
      </div>
    </div>
    <!-- <register-modal v-if="show_login" :register_type="register_type" ref="register_modal" @preLogin="preLogin"></register-modal> -->
    <!-- end pd20 -->
  </div>
</template>

<script>
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
import Config from "@/helpers/config";
import { EventBus } from "@/helpers/event-bus";
// import registerModal from "@/components/Profile/RegisterModal";
export default {
  name: "LoginPage",
  components: {
    MyHeader,
    Loading
    // registerModal
  },
  data() {
    return {
      type: "login",
      login_phone: "",
      register_phone: "",
      register_name: "",
      register_type: null,
      user: null,
      show_login: false,

      roles: Utils.listRoles()
    };
  },
  watch: {
    $route(to, from) {
      if (to.name == "RegisterPage") {
        this.type = "register";
      } else {
        this.type = "login";
      }
    }
  },
  computed: {
    registerTitle() {
      return "Đăng ký";
    }
  },
  methods: {
    // preLogin(data) {
    //   console.log("data", data);
    //   //  Utils.setCookie('pre_phone', data.phone)
    //   //  Utils.setCookie('pre_email', data.email)
    //   this.$refs.header.showLogin(data.email, data.phone, this.register_type);
    // },
    register(register_type) {
      // this.register_type = register_type;
      // this.show_login = true;
      // setTimeout(() => {
      //   this.$refs.register_modal.open();
      // }, 100);
      this.$refs.header.showLogin(register_type);
    }
  },
  mounted() {
    if (this.$route.params.type) {
      this.type = this.$route.params.type;
    }
    this.user = Utils.getUser(this);
    // console.log("type", this.type);
    // this.listenMessage();
  },
  beforeDestroy() {
    // prevent duplicated event
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Profile/LandingPage.vue